export default "__VITE_ASSET__pzTUGm7t__"